import { InfoCircleOutlined } from "@ant-design/icons";
import { Flex } from "antd";
import { FC, useCallback } from "react";
import { countText } from "tm-shared/utils";

import { useAppDispatch } from "@/hooks/redux";
import { BaseButton, BlockLoader, PrimaryText } from "@/shared/ui";
import { addModalToQueue } from "@/store/slices/ui";
import { ModalType } from "@/types";

import { StyledInfoContainer } from "./Styled";

const UploadButton = () => {
    const dispatch = useAppDispatch();

    const handleOpenUploadModal = useCallback(() => {
        dispatch(
            addModalToQueue({
                id: ModalType.UploadRetry,
                type: ModalType.UploadRetry,
                payload: { initialTab: "request" },
            }),
        );
    }, [dispatch]);

    return (
        <BaseButton onClick={handleOpenUploadModal} type="primary">
            Переглянути чергу
        </BaseButton>
    );
};

export const CheckoutQueueBlockedInfo = () => {
    return (
        <StyledInfoContainer>
            <PrimaryText fontSize={32} textColor="warning">
                <InfoCircleOutlined />
            </PrimaryText>

            <Flex vertical align="center" justify="center" gap={16}>
                <PrimaryText textAlign="center">
                    У черзі залишилися не синхронізовані замовлення
                </PrimaryText>

                <PrimaryText textAlign="center">
                    Кошик тимчасово недоступний, оскільки дані можуть бути
                    неактуальними
                </PrimaryText>

                <PrimaryText textAlign="center">
                    Щоб відновити роботу з кошиком, спочатку потрібно
                    вивантажити чергу
                </PrimaryText>
            </Flex>

            <UploadButton />
        </StyledInfoContainer>
    );
};

interface CheckoutQueueSyncingInfoProps {
    count: number;
}

export const CheckoutQueueSyncingInfo: FC<CheckoutQueueSyncingInfoProps> = ({
    count,
}) => {
    return (
        <StyledInfoContainer>
            <BlockLoader />

            <Flex vertical align="center" justify="center" gap={24}>
                <PrimaryText textAlign="center">
                    Відновився зв&apos;язок з сервером
                </PrimaryText>

                <PrimaryText textAlign="center">
                    Замовлення відправляються на обробку, тому робота з кошиком
                    тимчасово недоступна
                </PrimaryText>

                <PrimaryText textAlign="center">
                    {count === 0
                        ? "Всі замовлення відправлені, очікуємо підтвердження від сервера"
                        : `В черзі лишилося ${countText.order(count)} `}
                </PrimaryText>
            </Flex>

            <UploadButton />
        </StyledInfoContainer>
    );
};
